
import ReaderAppUsers from "../components/Dashboard/Users/ReaderAppUsers/ReaderAppUsers.vue";
import ReaderAppUser from "../components/Dashboard/Users/ReaderAppUsers/ReaderAppUser.vue";
import ReaderAppUserDetail from "../components/Dashboard/Users/ReaderAppUsers/ReaderAppUserDetail.vue";

const readerAppUserRoutes = [
    {
        path: "users/readerAppUsers",
        component: ReaderAppUsers,
        meta: {
            required: true,
            roles: ["PanelUser", "PanelVenueUser"],
        },
        name: "ReaderAppUsers",
    },
    {
        path: "users/readerAppUser",
        component: ReaderAppUser,
        meta: {
            required: true,
            roles: ["PanelUser", "PanelVenueUser"],
        },
        name: "ReaderAppUser",
    },
    {
        path: "users/readerAppUser/:id",
        component: ReaderAppUserDetail,
        meta: {
            required: true,
            roles: ["PanelUser", "PanelVenueUser"],
        },
        name: "ReaderAppUserDetail",
    },
]

export default readerAppUserRoutes;